/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAWebAgentLoginAuthRequest,
  PresenterAWebAgentLoginCodeResponse,
  PresenterAwebUserResponse,
  PresenterResponse,
  PresenterTenantUserActivationStatusesResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AWebUsers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get users list
   *
   * @tags AWeb-Users
   * @name GetAdminUsers
   * @summary Get users list
   * @request GET:/admin/users
   */
  getAdminUsers = (
    query?: {
      "filter[id]"?: number;
      "filter[identification_code]"?: string;
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAwebUserResponse[];
      },
      any
    >({
      path: `/admin/users`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get user by id
   *
   * @tags AWeb-Users
   * @name GetAdminUsersById
   * @summary Get user by id
   * @request GET:/admin/users/{id}
   */
  getAdminUsersById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAwebUserResponse;
      },
      any
    >({
      path: `/admin/users/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request verifying code, nonce and redirect url
   *
   * @tags AWeb-Users
   * @name PostAdminUsersByIdAgentLoginAuthorize
   * @summary Request verifying code, nonce and redirect url
   * @request POST:/admin/users/{id}/agent_login/authorize
   */
  postAdminUsersByIdAgentLoginAuthorize = (
    id: number,
    body: PresenterAWebAgentLoginAuthRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebAgentLoginCodeResponse;
      },
      any
    >({
      path: `/admin/users/${id}/agent_login/authorize`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check user uids activation or not
   *
   * @tags AWeb-Users
   * @name PostInternalTenantUserActivationStatuses
   * @summary Check user uids activation or not
   * @request POST:/internal/tenant_user_activation_statuses
   */
  postInternalTenantUserActivationStatuses = (params: RequestParams = {}) =>
    this.http.request<PresenterTenantUserActivationStatusesResponse, any>({
      path: `/internal/tenant_user_activation_statuses`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
